interface CatalogEmptyStateProps {
  hasActiveFilters: boolean;
  hasMatchedZone: boolean;
  onChangeAddress: () => void;
  onResetFilters: () => void;
}

export function CatalogEmptyState({
  hasActiveFilters,
  hasMatchedZone,
  onChangeAddress,
  onResetFilters,
}: CatalogEmptyStateProps) {
  const content = getEmptyStateContent(hasActiveFilters, hasMatchedZone);

  return (
    <section className="catalog-empty-state" aria-label="Товары не найдены">
      <div className="catalog-empty-state__visual" aria-hidden="true">
        <svg viewBox="0 0 64 64">
          <path d="M12 21.5 32 11l20 10.5v22L32 54 12 43.5Z" />
          <path d="m12 21.5 20 11 20-11M32 32.5V54" />
          <path d="m22 16.2 20 10.7v8.4" />
        </svg>
        <span>0</span>
      </div>
      <div className="catalog-empty-state__content">
        <p className="admin-eyebrow">Каталог пуст</p>
        <h2>{content.title}</h2>
        <p>{content.description}</p>
        <div className="catalog-empty-state__actions">
          {hasActiveFilters ? (
            <button className="workspace-secondary-button" onClick={onResetFilters} type="button">
              Сбросить фильтры
            </button>
          ) : null}
          <button className="catalog-empty-state__link" onClick={onChangeAddress} type="button">
            Выбрать другую точку
          </button>
        </div>
      </div>
    </section>
  );
}

function getEmptyStateContent(hasActiveFilters: boolean, hasMatchedZone: boolean) {
  if (hasActiveFilters) {
    return {
      title: 'По заданным условиям ничего не нашлось',
      description: 'Попробуйте изменить запрос, выбрать другую категорию или сбросить фильтры.',
    };
  }

  if (!hasMatchedZone) {
    return {
      title: 'Для этого адреса пока нет зоны доставки',
      description: 'Поставщики еще не обслуживают выбранную точку. Попробуйте выбрать другой адрес.',
    };
  }

  return {
    title: 'Ассортимент для этой точки пока пуст',
    description: 'Зона доставки определена, но поставщики еще не добавили доступные предложения.',
  };
}
